import { motion } from "framer-motion";

const FLOW = "M -20 770 H 760 Q 790 770 790 740 V 128 Q 790 98 820 98 H 1480";
const RETURN = "M -20 795 H 783 Q 813 795 813 765 V 153 Q 813 123 843 123 H 1480";
const JOINTS = [[360, 770], [700, 770], [1240, 98]];

export const PipeRun = ({ className = "" }) => (
  <svg viewBox="0 0 1440 800" preserveAspectRatio="xMidYMid slice" className={`pointer-events-none absolute inset-0 h-full w-full ${className}`} aria-hidden>
    <motion.path d={FLOW} fill="none" stroke="#1A5FC4" strokeWidth="2" strokeOpacity="0.55"
      initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 2.6, ease: [0.65, 0, 0.35, 1], delay: 0.3 }} />
    <motion.path d={RETURN} fill="none" stroke="#2F7A0A" strokeWidth="1.2" strokeOpacity="0.5" strokeDasharray="6 8"
      initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 3, ease: [0.65, 0, 0.35, 1], delay: 0.6 }} />
    {JOINTS.map(([x, y], i) => (
      <motion.g key={i} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2 + i * 0.35, duration: 0.6 }}>
        <circle cx={x} cy={y} r="5" fill="#FFFFFF" stroke="#1A5FC4" strokeWidth="1.5" />
        <text x={x - 12} y={y - 12} textAnchor="end" fill="#5B6573" fillOpacity="0.7" fontFamily="JetBrains Mono, monospace" fontSize="11" letterSpacing="1.5">
          {`F-${String(i + 1).padStart(2, "0")} · Ø22`}
        </text>
      </motion.g>
    ))}
  </svg>
);
